// extracted by mini-css-extract-plugin
export default {"Shop":"Shop_Shop__6Q7A1"};